var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    {
      staticClass: "pt-2"
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "py-0",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("gg-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "emailField",
                attrs: {
                  outlined: "",
                  label: "Email Address",
                  dense: "",
                  placeholder: "ex. yourname",
                  autocomplete: "new-password",
                  name: "Email",
                  "error-messages": _vm.errors.collect("Email")
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function fn() {
                      return [
                        !_vm.isMobileDevice
                          ? _c(
                              "div",
                              {
                                staticClass: "append-bg"
                              },
                              [
                                _c("domain-select", {
                                  style: {
                                    width: "".concat(_vm.domainWidth, "px"),
                                    minWidth: "180px",
                                    maxWidth: "".concat(
                                      _vm.domainMaxWidth,
                                      "px"
                                    )
                                  },
                                  attrs: {
                                    "no-label": "",
                                    "hide-details": "",
                                    flat: "",
                                    solo: "",
                                    "prepend-inner-icon": "mdi-at"
                                  },
                                  model: {
                                    value: _vm.model.selectedDomain,
                                    callback: function callback($$v) {
                                      _vm.$set(_vm.model, "selectedDomain", $$v)
                                    },
                                    expression: "model.selectedDomain"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.model.email,
                  callback: function callback($$v) {
                    _vm.$set(_vm.model, "email", $$v)
                  },
                  expression: "model.email"
                }
              })
            ],
            1
          ),
          _vm.isMobileDevice
            ? _c(
                "v-col",
                {
                  staticClass: "py-0",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-scale-transition",
                    [
                      _c("domain-select", {
                        attrs: {
                          outlined: "",
                          label: "Select a Domain",
                          "prepend-inner": false
                        },
                        model: {
                          value: _vm.model.selectedDomain,
                          callback: function callback($$v) {
                            _vm.$set(_vm.model, "selectedDomain", $$v)
                          },
                          expression: "model.selectedDomain"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            {
              staticClass: "py-0",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("gg-input-label", [_vm._v("Password")]),
              _c("compact-password", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  outlined: "",
                  autocomplete: "new-password",
                  "data-vv-name": "password",
                  "data-vv-as": "Password",
                  "error-messages": _vm.errors.collect("password"),
                  "with-generator": ""
                },
                model: {
                  value: _vm.model.password,
                  callback: function callback($$v) {
                    _vm.$set(_vm.model, "password", $$v)
                  },
                  expression: "model.password"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "py-0",
              attrs: {
                cols: "12"
              }
            },
            [
              _c("v-switch", {
                staticClass: "mt-0",
                attrs: {
                  color: "green",
                  label:
                    "Send welcome email with mail client configuration instructions."
                },
                model: {
                  value: _vm.sendSettings,
                  callback: function callback($$v) {
                    _vm.sendSettings = $$v
                  },
                  expression: "sendSettings"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "gg-btn",
        {
          attrs: {
            primary: "",
            loading: _vm.loading
          },
          on: {
            click: _vm.addEmail
          }
        },
        [_vm._v(" Create account ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }